import type { Fighter, Scene } from './types';

export interface RingColor { rgb: string; fill: string }
export const RING_GREEN: RingColor = { rgb: '57,208,90', fill: '#39d05a' };
export const RING_RED: RingColor = { rgb: '255,71,71', fill: '#ff4747' };
export const RING_SMOKE: RingColor = { rgb: '150,170,185', fill: '#9aaab9' };

export function drawRing(sc: Scene, f: Fighter, now: number, c: RingColor) {
  const { ctx } = sc;
  const pulse = 0.5 + 0.5 * Math.sin(now * 4);
  const rx = 72 + pulse * 7, ry = 26 + pulse * 3;
  ctx.save();
  ctx.strokeStyle = 'rgba(0,0,0,0.55)';
  ctx.lineWidth = 11;
  ctx.beginPath();
  ctx.ellipse(f.x, f.y - 2, rx, ry, 0, 0, Math.PI * 2);
  ctx.stroke();
  ctx.strokeStyle = `rgba(${c.rgb},0.35)`;
  ctx.lineWidth = 14;
  ctx.beginPath();
  ctx.ellipse(f.x, f.y - 2, rx, ry, 0, 0, Math.PI * 2);
  ctx.stroke();
  ctx.strokeStyle = `rgb(${c.rgb})`;
  ctx.lineWidth = 6;
  ctx.beginPath();
  ctx.ellipse(f.x, f.y - 2, rx, ry, 0, 0, Math.PI * 2);
  ctx.stroke();
  ctx.restore();

  if (f.dead) return;
  drawMarkers(sc, f, now, c);
}

function drawMarkers(sc: Scene, f: Fighter, now: number, c: RingColor) {
  const { ctx } = sc;
  const cx = f.x, cy = f.y - 2;
  const rx = 84, ry = 31;
  const N = 3;
  const spin = now * 2.1;
  ctx.save();
  for (let i = 0; i < N; i++) {
    const a = spin + (i * 2 * Math.PI) / N;
    const px = cx + rx * Math.cos(a);
    const py = cy + ry * Math.sin(a);
    const ang = Math.atan2(cy - py, cx - px);
    ctx.save();
    ctx.translate(px, py);
    ctx.rotate(ang);
    const s = 10;
    ctx.beginPath();
    ctx.moveTo(-s, -s * 0.9);
    ctx.lineTo(s, 0);
    ctx.lineTo(-s, s * 0.9);
    ctx.lineTo(-s * 0.35, 0);
    ctx.closePath();
    ctx.fillStyle = c.fill;
    ctx.fill();
    ctx.lineWidth = 2.5;
    ctx.strokeStyle = 'rgba(0,0,0,0.8)';
    ctx.stroke();
    ctx.restore();
  }
  ctx.restore();
}
